import { render, staticRenderFns } from "./FollowButtonController.vue?vue&type=template&id=6520a9c6&scoped=true&"
import script from "./FollowButtonController.vue?vue&type=script&lang=ts&"
export * from "./FollowButtonController.vue?vue&type=script&lang=ts&"
import style0 from "./FollowButtonController.vue?vue&type=style&index=0&id=6520a9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520a9c6",
  null
  
)

export default component.exports